import auth0 from 'auth0-js';

class Auth0SSOProvider {
  configure = options => {
    // If we have the redirect URI built-in, we can let it override for the sake of testing on
    // different environments such as dev builds and beta.
    const redirectUri = process.env.REACT_APP_AUTH0_REDIRECT_URI || options.redirectUri || '';
    this.handler = new auth0.WebAuth({ ...options, redirectUri });
  };

  authorize = async connection => {
    this.handler.authorize({ connection });
  };

  authenticate = async () => {
    return new Promise((resolve, reject) => {
      this.handler.parseHash((err, authResult) => {
        if (err) {
          reject(new Error(err));
        } else {
          resolve(authResult.accessToken);
        }
      });
    });
  };
}

export const provider = new Auth0SSOProvider();
